import { render, staticRenderFns } from "./FooterValueProps.vue?vue&type=template&id=1ad76195&scoped=true&lang=pug&"
import script from "./FooterValueProps.vue?vue&type=script&lang=js&"
export * from "./FooterValueProps.vue?vue&type=script&lang=js&"
import style0 from "./FooterValueProps.vue?vue&type=style&index=0&id=1ad76195&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad76195",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad76195')) {
      api.createRecord('1ad76195', component.options)
    } else {
      api.reload('1ad76195', component.options)
    }
    module.hot.accept("./FooterValueProps.vue?vue&type=template&id=1ad76195&scoped=true&lang=pug&", function () {
      api.rerender('1ad76195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/footer/FooterValueProps.vue"
export default component.exports